import { formatFinancialCurrency } from 'partner360/lib/metricFormatting'

export const formatCurrency = (value: number | null | undefined): string =>
  formatFinancialCurrency(value)
